// Helper functions shared by the 4 recipients preview modals
// (EventUpdatesRecipientsModal, NewShipmentRecipientsModal,
//  CompleteShipmentRecipientsModal, ApprovalModal)

/**
 * Generate CIF description text for consignee groups
 * @param {Object} consigneeGroup - Consignee group data
 * @returns {string} Description text
 */
export const generateCIFDescription = (consigneeGroup) => {
  // Detectar si hay casos CIF en este grupo
  const hasCIF = consigneeGroup.recipients.some(r =>
    r.type === 'Consignatario (CIF)' || r.type === 'Usuario Notificado (CIF)'
  );

  // Detectar si hay Vendedor en este grupo
  const hasVendedor = consigneeGroup.recipients.some(r => r.type === 'Vendedor');

  if (consigneeGroup.ffUser) {
    // Caso con Freight Forwarder
    let description = 'Freight Forwarder';
    if (hasVendedor) description += ' + Vendedor';
    if (hasCIF) description += ' + CIF (consignatario + notificados)';
    return description;
  } else {
    // Caso sin Freight Forwarder
    let description = 'Consignatario + usuarios relacionados';
    if (hasVendedor) description += ' + Vendedor';
    if (hasCIF) description += ' + CIF adicional';
    return description;
  }
};

/**
 * Get badge color classes for a recipient type.
 * Matching por subcadena: el orden importa — 'Notificado Proveedor' antes que
 * 'Notificado' y 'Proveedor'; 'Notificado' antes que el resto porque
 * 'Usuario Notificado (Transportista)' contiene 'Transportista'.
 * @param {string} type - Recipient type emitted by the backend
 * @returns {string} Tailwind classes
 */
export const getBadgeColor = (type) => {
  if (!type) return 'text-gray-600 bg-gray-100';
  if (type.includes('Notificado Proveedor')) return 'text-teal-600 bg-teal-100';
  if (type.includes('Notificado')) return 'text-blue-600 bg-blue-100';
  if (type.includes('Proveedor')) return 'text-green-600 bg-green-100';
  if (type.includes('Consignatario')) return 'text-indigo-600 bg-indigo-100';
  if (type.includes('Freight Forwarder')) return 'text-orange-600 bg-orange-100';
  if (type.includes('Vendedor')) return 'text-purple-600 bg-purple-100';
  return 'text-gray-600 bg-gray-100'; // Usuario Logueado, Notificación por Defecto
};
